"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributeIncreaseEffectHandler = exports.AttributeIncreaseEffectArgs = void 0;
const Registries_1 = require("../../state/Registries");
const EffectType_1 = require("../EffectType");
class AttributeIncreaseEffectArgs {
    constructor() {
        this.__type = EffectType_1.EffectType.AttributeIncrease;
        this.__typeName = "AttributeIncrease";
        this.name = "Attribute Increase";
        this.harmful = true;
    }
}
exports.AttributeIncreaseEffectArgs = AttributeIncreaseEffectArgs;
let AttributeIncreaseEffectHandler = class AttributeIncreaseEffectHandler {
    apply(sequence, container, state) {
        throw new Error("DO NOT USE");
    }
    remove(sequence, container, state) {
    }
};
AttributeIncreaseEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.AttributeIncrease)
], AttributeIncreaseEffectHandler);
exports.AttributeIncreaseEffectHandler = AttributeIncreaseEffectHandler;
